import { teamBadgeAliases } from './teamBadgeAliases';

export default class Helpers {
    static findTeamImageModule(teamName) {
        const normalized = this.formatTextForAssetNames(teamName);
        const reformattedTeamName = teamBadgeAliases[normalized] || normalized;
        try {
            return require(`../assets/teamBadges/${reformattedTeamName}-logo-icon.png`)
        } catch (e) {
            try {
                // Fallback to .webp (e.g. World Cup national-team flags sourced as webp)
                return require(`../assets/teamBadges/${reformattedTeamName}-logo-icon.webp`)
            } catch (eWebp) {
                try {
                    return require(`../assets/default-badge.png`)
                } catch (e2) {
                    return '';
                }
            }
        }
    }

    static findLeagueImageModule(league) {
        const name = typeof league === "object" ? league.leagueName : league
        const reformattedLeagueName = this.formatTextForAssetNames(name);
        try {
            return require(`../assets/leagueLogos/${reformattedLeagueName}-logo-colour.png`)
        } catch (e) {
            try {
                return require(`../assets/default-badge.png`)
            } catch (e2) {
                return '';
            }
        }
    }

    static findPlayerImageModule(playerName) {
        const formattedPlayerName = this.formatTextForAssetNames(playerName);
        try {
            return require(`../assets/players/${formattedPlayerName}.webp`);
        } catch (e) {
            try {
                return require(`../assets/default-badge.png`);
            } catch (e2) {
                return '';
            }
        }
    }

    static formatTextForAssetNames(text) {
        if (!text) return 'default';
        const lowerCase = text.toLowerCase();
        return lowerCase.replaceAll(' ', '-');
    }

    static formatNumber(num) {
        if (num === null || num === undefined) return '0';
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    static truncateText(text, maxLength = 50) {
        if (!text) return '';
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    }
}
